export default [
  'My Account',
  'Gift Voucher',
  'Partner',
  'CRM',
  'Verify Email',
  'Article',
  'Regular',
]
